(() => {
  const observers = new Map();
  const isOpen = element => element.tagName === 'DIALOG' ? element.open : !element.hidden && !element.hasAttribute('x-cloak') && element.getAttribute('aria-hidden') !== 'true' && !element.inert && element.style.display !== 'none' && element.style.opacity !== '0';
  const update = () => {
    const next = String([...observers.keys()].some(isOpen));
    if (document.body.dataset.cluxDialogOpen !== next) document.body.dataset.cluxDialogOpen = next;
  };
  const stop = () => { for (const observer of observers.values()) observer.disconnect(); observers.clear(); };
  const start = () => {
    if (document.hidden) return;
    document.querySelectorAll('dialog, [role="dialog"][aria-modal="true"]').forEach(element => {
      if (observers.has(element)) return;
      const observer = new MutationObserver(update);
      observer.observe(element, {attributes: true, attributeFilter: ['open', 'hidden', 'inert', 'aria-hidden', 'x-cloak', 'style']});
      observers.set(element, observer);
    });
    update();
  };
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
